import { createAction, props, union } from '@ngrx/store';

import { DeepLinkSource } from '@fcom/common/interfaces';

import { UpgradeResponse } from '../../api/models/upgrade-response';

export const setDeepLinkSource = createAction('[Upgrade] Set Deep Link Source', props<{ source: DeepLinkSource }>());
export const setUpgradeResponse = createAction(
  '[Upgrade] Set Upgrade Response',
  props<{ upgradeResponse: UpgradeResponse }>()
);
export const clearDeepLinkSource = createAction('[Upgrade] Clear Deep Link Source');
export const clearFlights = createAction('[Upgrade] Clear Flights');
export const clearPassengers = createAction('[Upgrade] Clear Passengers');
export const clearAll = createAction('[Upgrade] Clear Flights, Passengers and basket');

const all = union({
  setDeepLinkSource,
  setUpgradeResponse,
  clearDeepLinkSource,
  clearFlights,
  clearPassengers,
  clearAll,
});
export type DataActionsUnion = typeof all;
